import { Transform } from 'class-transformer';
import { IsNotEmpty, IsObject, IsString, MaxLength } from 'class-validator';
import { SURVEY_INVITE_TOKEN_MAX_LENGTH } from '../../types/survey-invite';
import type { SurveyAnswers } from '../survey/survey-answers.types';

function trimString({ value }: { value: unknown }): unknown {
  return typeof value === 'string' ? value.trim() : value;
}

/** Body of `POST public/survey-invites/session`: the secret never travels in the path (nginx/APM log it). */
export class CreatePublicSurveyInviteSessionDto {
  @Transform(trimString)
  @IsString()
  @IsNotEmpty()
  @MaxLength(SURVEY_INVITE_TOKEN_MAX_LENGTH)
  token!: string;
}

export class ValidatePublicSurveyInviteAnswersDto {
  @IsObject()
  answers!: SurveyAnswers;
}

export interface PublicSurveyInviteDraftSavedDto {
  savedAt: string;
}

export interface PublicSurveyInviteSignatureSavedDto {
  hasSignature: true;
}

export interface PublicSurveyInviteViolationDto {
  nodeId: string;
  detail: string;
}

export interface PublicSurveyInviteValidationDto {
  violations: PublicSurveyInviteViolationDto[];
}
